var _style, _rect, _path, _g, _g2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftOnedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st2{opacity:0.2;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.12;}\n\t.st5{fill:#0364B8;}\n\t.st6{fill:#0F78D4;}\n\t.st7{fill:#1490DF;}\n\t.st8{fill:#28A8EA;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.0811,
    y1: 180.214,
    x2: 368.7052,
    y2: -80.8579,
    gradientTransform: "matrix(1 0 0 -1 -50 328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.7
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393,218.3c-18.9-73.8-94.2-118.3-168-99.4c-33.3,8.5-62.1,29.2-81,57.8c-60.8,0.4-110,50-109.6,111.1 c0.4,60.8,50,110,111.1,109.6h241.4c49.5,0.5,90-39.1,90.7-88.6C478.1,260.8,440.9,220.8,393,218.3L393,218.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M393,218.3c-18.9-73.8-94.2-118.3-168-99.4c-33.3,8.5-62.1,29.2-81,57.8c-60.8,0.4-110,50-109.6,111.1 c0.4,60.8,50,110,111.1,109.6h241.4c49.5,0.5,90-39.1,90.7-88.6C478.1,260.8,440.9,220.8,393,218.3L393,218.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M393,218.3c-18.9-73.8-94.2-118.3-168-99.4c-33.3,8.5-62.1,29.2-81,57.8c-60.8,0.4-110,50-109.6,111.1 c0.4,60.8,50,110,111.1,109.6h241.4c49.5,0.5,90-39.1,90.7-88.6C478.1,260.8,440.9,220.8,393,218.3L393,218.3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.9,198.1L200.9,198.1l96.3,57.8l57.2-23.8l0,0c11.7-5,24.3-7.6,36.9-7.6h6.3 c-19.6-76.7-97.7-122.8-174.2-103.1c-34.6,8.8-64.4,30.2-84.1,59.9h1.4C162,181.2,182.9,187,200.9,198.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.5,193.8L202.5,193.8c-17.5-10.6-37.4-16.4-57.8-16.4h-1.1c-31.3,0-62.1,12.8-82.1,37.1 c-34.9,42.3-34.6,96.7-7.7,135.7l82.1-34.4l36.4-15.3l81-34l42.5-17.6L202.5,193.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.2,218.5H387c-12.2,0-24.3,2.5-35.6,7.4l0,0l-56,22.9L465.9,351c23.4-43.7,7-98.1-36.7-121.5 C418.2,223.3,405.9,219.2,393.2,218.5L393.2,218.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M295.6,248.5l-42.5,17.6l-81,34l-36.4,15.3l-82.1,34.4c20.7,29.7,54.5,47.3,90.9,47.2h242.1 c33.1,0,63.7-17.3,79.6-46.3L295.6,248.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOnedrive);
export default __webpack_public_path__ + "static/media/microsoft-onedrive.8bd86544ac23338e08eabf383bedb7e5.svg";
export { ForwardRef as ReactComponent };